export default {
  'menu.home': 'Casa',
  'menu.login': 'Iniciar sessão',
  'menu.register': 'Inscrição',
  'menu.findPassword': 'Esquecer a senha',
  'menu.account.logout': 'Logout',
  'menu.about': 'Sobre',
  'menu.product':'Produto',
  'menu.product.challenge-rules':'Regras do Desafio',
  'menu.product.elite-competition':'Competição de Elite',
  'menu.product.personal-challenge':'Desafio Pessoal',
  'menu.product.month-challenge':'Desafio Mensal',
  'menu.develop':'Desenvolver',
  'menu.develop.partnership-program':'Programa de Parceria',
  'menu.develop.trader-recruitment':'Recrutamento de Traders',
  'menu.download':'Baixar',
  'menu.FAQ':'Perguntas Freqüentes',
  'menu.FAQ.list':'Lista de FAQ',
  'menu.FAQ.detail':'FAQ Detalhes',
  'menu.account': 'Centro Individual',
  'menu.account.personal': 'Perfil',
  'menu.account.instrument-panel': 'Painel',
  'menu.account.instrument-panel-detail': 'Detalhes',
  'menu.account.product': 'produto',
  'menu.account.purchaseEvaluation': 'Avaliação de Compra',
  'menu.account.earn': 'Promoção',
  'menu.account.earn.integral': 'Detalhes do ponto',
  'menu.account.earn.product': 'Troca de produtos',
  'menu.account.earn.invitation': 'Registro de convite',
  'menu.account.earn.commission': 'Detalhes da comissão de retorno',
  'menu.account.payout': 'ativos',
  'menu.account.payout.transfer': 'transferência',
  'menu.account.payout.transferList': 'Registro de transferência',
  'menu.account.payout.withdrawal': 'Saque',
  'menu.account.payout.withdrawalList': 'Registro de saque',
  'menu.account.payout.withdrawalDetails': 'Detalhes da retirada',
  'menu.account.payout.inAndOutAccountList': 'Registros de entrada e saída',
  'menu.account.my': 'meu',
  'menu.account.my.personal': 'Perfil',
  'menu.account.my.accountInfo': 'Informações da conta',
  'menu.account.my.certification': 'Certificação',
  'menu.account.my.certificate': 'Certificado',
  'menu.account.my.order': 'Lista de pedidos',
  'menu.account.my.contactUs': 'Fale Conosco',
  'menu.account.my.orderDetail': 'Detalhes do pedido',
  'menu.account.my.findPassword': 'Esquecer a senha',


  'menu.welcome': 'Welcome',
  'menu.more-blocks': 'More Blocks',
  'menu.admin': 'Admin',
  'menu.admin.sub-page': 'Sub-Page',
  'menu.register-result': 'Resultado de registro',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': 'Análise',
  'menu.dashboard.monitor': 'Monitor',
  'menu.dashboard.workplace': 'Ambiente de Trabalho',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'Formulário',
  'menu.form.basic-form': 'Formulário Básico',
  'menu.form.step-form': 'Formulário Assistido',
  'menu.form.step-form.info': 'Formulário Assistido(gravar informações de transferência)',
  'menu.form.step-form.confirm': 'Formulário Assistido(confirmar informações de transferência)',
  'menu.form.step-form.result': 'Formulário Assistido(finalizado)',
  'menu.form.advanced-form': 'Formulário Avançado',
  'menu.list': 'Lista',
  'menu.list.table-list': 'Tabela de Busca',
  'menu.list.basic-list': 'Lista Básica',
  'menu.list.card-list': 'Lista de Card',
  'menu.list.search-list': 'Lista de Busca',
  'menu.list.search-list.articles': 'Lista de Busca(artigos)',
  'menu.list.search-list.projects': 'Lista de Busca(projetos)',
  'menu.list.search-list.applications': 'Lista de Busca(aplicações)',
  'menu.profile': 'Perfil',
  'menu.profile.basic': 'Perfil Básico',
  'menu.profile.advanced': 'Perfil Avançado',
  'menu.result': 'Resultado',
  'menu.result.success': 'Sucesso',
  'menu.result.fail': 'Falha',
  'menu.exception': 'Exceção',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'Disparar',
  'menu.account': 'Conta',
  'menu.account.center': 'Central da Conta',
  'menu.account.settings': 'Configurar Conta',
  'menu.account.trigger': 'Disparar Erro',
  'menu.account.logout': 'Sair',
  'menu.editor': 'Graphic Editor',
  'menu.editor.flow': 'Flow Editor',
  'menu.editor.mind': 'Mind Editor',
  'menu.editor.koni': 'Koni Editor',
    'menu.mine': 'Meu',
};
